import _ from 'lodash';

// constants
import { SCRIPT_URI_ADDON, TABLE_URI_ADDON } from '../../../constants/constant';
import {
  FIELDS,
  SCRIPTS,
  TABLES
} from '../../../constants/section-constants/eventify-constant';
import { getRequest, postRequest } from '../../Common/network-call';

export const FETCH_CHALLENGES = 'FETCH_CHALLENGES';
export const FETCH_LEADERBOARD = 'FETCH_LEADERBOARD';
export const FETCH_TEAM_LEADERBOARD = 'FETCH_TEAM_LEADERBOARD';
export const SHOWPOPUP_MODAL = 'SHOWPOPUP_MODAL';
export const CERTIFICATE_MODAL = 'CERTIFICATE_MODAL';
export const USER_GAME_POINTS = 'USER_GAME_POINTS';

export const fetchGameChallenges = (session, callback = null) => {
  let url = `${session.instance_url}${SCRIPT_URI_ADDON}/${SCRIPTS.gamificationScript.achievements.endpoint}`;
  let body = _.cloneDeep(SCRIPTS.gamificationScript.achievements.payload);
  body.eventid = session.eventid;
  body.userid = session.userid;

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        let responsePayload = {
          data: [],
          triviaForms: null
        };
        if (response?.length) {
          // --- Fetching game log additionally
          dispatch(fetchUserGamePointsLog(session));

          const sortedData = _.chain(response)
            .map(obj => {
              obj.apptabid = obj.apptabid ? Number(obj.apptabid) : obj.apptabid;
              obj.challengeidfk = obj.challengeidfk
                ? Number(obj.challengeidfk)
                : obj.challengeidfk;
              obj.displayorder = parseInt(obj.displayorder);
              obj.eventid = Number(obj.eventid);
              obj.id = Number(obj.id);
              obj.isactive = parseInt(obj.isactive);
              obj.isrecurring = parseInt(obj.isrecurring);
              obj.max_points_limit = parseInt(obj.max_points_limit);
              obj.points = parseInt(obj.points);
              obj.relatedid = Number(obj.relatedid);
              obj.sessionid = obj.sessionid
                ? Number(obj.sessionid)
                : obj.sessionid;
              obj.settings_json =
                _.attempt(JSON.parse, obj.settings_json) || obj.settings_json;
              obj.showpopup = parseInt(obj.showpopup);
              return obj;
            })
            .orderBy(['displayorder', 'challengename'], ['asc', 'asc'])
            .value();

          responsePayload.data = sortedData;

          const triviaRelatedFormIds = _.chain(response)
            .filter(challenge => _.isEqual(challenge?.challengetype, 'trivia'))
            .map(ea => ea.relatedid)
            .compact() // removes undefined, null, 0 etc falsy values
            .value();

          if (!_.isEmpty(triviaRelatedFormIds)) {
            dispatch(
              fetchTriviaForms(
                session,
                { formIds: triviaRelatedFormIds },
                res => {
                  if (res?.success) {
                    responsePayload.triviaForms = res?.data;

                    dispatch({
                      type: FETCH_CHALLENGES,
                      payload: responsePayload
                    });
                    callback &&
                      callback({
                        success: 1,
                        error: null,
                        ...responsePayload
                      });
                  } else {
                    dispatch({
                      type: FETCH_CHALLENGES,
                      payload: responsePayload
                    });
                    callback &&
                      callback({
                        success: 1,
                        error: null,
                        ...responsePayload
                      });
                  }
                }
              )
            );
          } else {
            dispatch({
              type: FETCH_CHALLENGES,
              payload: responsePayload
            });
            callback &&
              callback({
                success: 1,
                error: null,
                ...responsePayload
              });
          }
        } else {
          dispatch({
            type: FETCH_CHALLENGES,
            payload: responsePayload
          });
          callback && callback({ success: 0, error: null, ...responsePayload });
        }
      },
      error => {
        callback && callback({ success: 0, error, data: null });
      }
    );
  };
};

export const setGameChallengeEmpty = callback => {
  return dispatch => {
    dispatch({
      type: FETCH_CHALLENGES,
      payload: {}
    });
    callback({ success: 1 });
  };
};

export const setGameLeaderBoardEmpty = callback => {
  return dispatch => {
    dispatch({
      type: FETCH_LEADERBOARD,
      payload: {}
    });
    callback({ success: 1 });
  };
};

export const fetchGameLeaderBoard = (
  session,
  forTeam = false,
  callback = () => {}
) => {
  let url = `${session.instance_url}${SCRIPT_URI_ADDON}/${
    forTeam
      ? SCRIPTS.gamificationScript.teamLeaderBoard.endpoint
      : SCRIPTS.gamificationScript.leaderboard.endpoint
  }`;
  let body = _.cloneDeep(SCRIPTS.gamificationScript.leaderboard.payload);
  body.eventid = session.eventid;
  body.userid = session.userid;

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        dispatch({
          type: forTeam ? FETCH_TEAM_LEADERBOARD : FETCH_LEADERBOARD,
          payload: response
        });
        callback({ success: 1, response });
      },
      error => {
        callback({ success: 0, error: error });
      }
    );
  };
};

export const fetchGameChallengeStatus = (session, challengetype, callback) => {
  let url = `${session.instance_url}${SCRIPT_URI_ADDON}/${SCRIPTS.gamificationScript.fetchGameChallengeStatus.endpoint}`;
  let body = _.cloneDeep(
    SCRIPTS.gamificationScript.fetchGameChallengeStatus.payload
  );
  body.eventid = session.eventid;
  body.userid = session.userid;
  body.challengetype = `${challengetype}`;

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        callback({ success: 1, data: response.resource });
      },
      error => {
        callback({ success: 0, error: error });
      }
    );
  };
};

export const fetchTriviaChallengeStatus = (
  session,
  extra = { challengetype: '', appTabId: null, relatedId: null },
  callback
) => {
  let url = `${session.instance_url}${SCRIPT_URI_ADDON}/${SCRIPTS.gamificationScript.fetchGameChallengeStatus.endpoint}`;
  let body = _.cloneDeep(
    SCRIPTS.gamificationScript.fetchGameChallengeStatus.triviaPayload
  );
  body.eventid = session.eventid;
  body.userid = session.userid;
  body.challengetype = `${extra.challengetype}`;
  body.apptabid = extra.appTabId;
  body.relatedid = extra.relatedId;

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        callback({ success: 1, data: response.resource });
      },
      error => {
        callback({ success: 0, error: error });
      }
    );
  };
};

export const setGamificationPopup = (showModal = false, item = {}) => {
  return dispatch => {
    dispatch({
      type: SHOWPOPUP_MODAL,
      payload: {
        showModal,
        item
      }
    });
  };
};

export const pointCredited = (session, challengetype, userid, callback) => {
  let url = `${session.instance_url}${SCRIPT_URI_ADDON}/${SCRIPTS.gamificationScript.fetchGameChallengeStatus.endpoint}`;
  let body = _.cloneDeep(
    SCRIPTS.gamificationScript.fetchGameChallengeStatus.payload
  );
  body.eventid = session.eventid;
  body.userid = session.userid;
  body.challengetype = `${challengetype}`;

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        callback({ success: 1, data: response.resource });
      },
      error => {
        callback({ success: 0, error: error });
      }
    );
  };
};

export const openRewardModal = (showModal = false, awardimg = '') => {
  return dispatch => {
    dispatch({
      type: CERTIFICATE_MODAL,
      payload: {
        showModal: showModal,
        awardimg: awardimg
      }
    });
  };
};

export const fetchUserGamePointsLog = (session, callback = null) => {
  let fetchFilter = encodeURI(
    `((eventid=${session.eventid})AND(userid=${session.userid}))`
  );
  let fetchUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.gameUserPointsLog}?fields=${FIELDS.gameUserPointsLog.mediumInfo}&filter=${fetchFilter}`;

  return dispatch => {
    getRequest(
      fetchUrl,
      session,
      dispatch,
      res => {
        dispatch({ type: USER_GAME_POINTS, payload: res?.resource });
        callback && callback({ success: 1, data: res?.resource, error: null });
      },
      error => {
        callback && callback({ success: 0, data: null, error });
      }
    );
  };
};

const fetchTriviaForms = (session, extra = { formIds: [] }, callback) => {
  const fetchFilter = encodeURI(
    `((eventid=${
      session.eventid
    })AND(formtype=trivia)AND(ispublished=1)AND(formid IN (${_.join(
      extra.formIds,
      ','
    )})))`
  );
  const fetchUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.eventForms}?fields=${FIELDS.eventForms.mediumInfo}&filter=${fetchFilter}`;

  return dispatch => {
    getRequest(
      fetchUrl,
      session,
      dispatch,
      res => {
        callback({ success: 1, data: res?.resource, error: null });
      },
      error => {
        callback({ success: 0, data: null, error });
      }
    );
  };
};
